import { useState } from 'react';

// Dosyalar site/public/video (kaynak: doc/Mahallebi/09_MARKA_HAREKET/tanitim, web icin 720p'ye kodlandi).
const FILM = {
  yatay: { src: '/video/mahallebi-tanitim-45sn-720p.mp4', kapak: '/video/tanitim-kapak.webp', sure: '45 sn' },
  dikey: { src: '/video/mahallebi-tanitim-20sn-dikey.mp4', kapak: '/video/tanitim-kapak-dikey.webp', sure: '20 sn' },
};
// Dar ekranda dikey kurgu: kapak <picture>, kutu orani ve video secimi ayni kirilim noktasini kullanir (sm).
const DAR_EKRAN = '(max-width: 639px)';

const videoJsonLd = JSON.stringify({
  '@context': 'https://schema.org',
  '@type': 'VideoObject',
  name: 'Bir Mahalle Günü — Mahallebi tanıtım filmi',
  description:
    'Sabah bir ilan, bir mesaj, mahallenin esnafı ve akşam bir komşuya acil yardım: Mahallebi ile bir mahalle günü 45 saniyede.',
  thumbnailUrl: 'https://mahallebi.com/video/tanitim-kapak.webp',
  uploadDate: '2026-10-02',
  duration: 'PT45S',
  contentUrl: 'https://mahallebi.com/video/mahallebi-tanitim-45sn-720p.mp4',
  inLanguage: 'tr',
  publisher: { '@id': 'https://mahallebi.com/#organization' },
});

/**
 * Tanitim filmi "Bir Mahalle Gunu". Sayfa acilisinda yalniz kapak gorseli yuklenir;
 * video dosyasi oynat'a basilinca iner (sayfa hizi etkilenmez).
 */
export default function TanitimFilmi() {
  const [oynuyor, setOynuyor] = useState<null | 'yatay' | 'dikey'>(null);

  const oynat = () => {
    setOynuyor(window.matchMedia(DAR_EKRAN).matches ? 'dikey' : 'yatay');
  };

  return (
    <section id="film" className="py-16 sm:py-24 bg-white">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: videoJsonLd }} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-10 sm:mb-12">
          <span className="inline-block text-xs font-bold tracking-[0.12em] uppercase text-[#e77e23] mb-3">
            Tanıtım filmi
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#111827] mb-4">Bir mahalle günü</h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            Sabah bir ilan, öğlen mahallenin esnafı, akşam bir komşuya yardım. Mahallebi'de bir gün, kısacık bir filmde.
          </p>
        </div>

        <div className="relative mx-auto w-full max-w-[360px] aspect-[9/16] sm:max-w-4xl sm:aspect-video rounded-2xl sm:rounded-3xl overflow-hidden shadow-2xl bg-[#211811]">
          {oynuyor ? (
            <video
              src={FILM[oynuyor].src}
              poster={FILM[oynuyor].kapak}
              className="w-full h-full object-cover"
              controls
              autoPlay
              playsInline
              preload="auto"
            >
              Tarayıcınız video oynatmayı desteklemiyor.
            </video>
          ) : (
            <button
              type="button"
              onClick={oynat}
              className="group absolute inset-0 w-full h-full cursor-pointer"
              aria-label="Tanıtım filmini oynat"
            >
              <picture>
                <source media={DAR_EKRAN} srcSet={FILM.dikey.kapak} />
                <img
                  src={FILM.yatay.kapak}
                  alt="Bir Mahalle Günü tanıtım filminden bir kare: balkonda telefonundan ilan veren bir komşu"
                  className="w-full h-full object-cover"
                  loading="lazy"
                  decoding="async"
                />
              </picture>
              <span className="absolute inset-0 bg-gradient-to-t from-black/45 via-black/5 to-transparent" />
              <span className="absolute inset-0 flex items-center justify-center">
                <span className="relative flex items-center justify-center w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-[#e77e23] text-white shadow-xl transition-transform duration-300 group-hover:scale-110 group-focus-visible:scale-110">
                  <i className="ri-play-fill text-4xl sm:text-5xl relative ml-1" aria-hidden="true" />
                </span>
              </span>
              <span className="absolute left-4 bottom-4 sm:left-6 sm:bottom-6 inline-flex items-center gap-2 rounded-full bg-black/55 px-3 py-1.5 text-sm font-semibold text-white backdrop-blur-sm">
                <i className="ri-film-line" aria-hidden="true" />
                <span className="sm:hidden">{FILM.dikey.sure}</span>
                <span className="hidden sm:inline">{FILM.yatay.sure}</span>
              </span>
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
